import Quill, { Parchment } from '@kim/quill';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EmbedCtor = Quill.import('blots/embed') as Parchment.BlotConstructor;

export interface MentionBlotValue {
  id: string;
  name: string;
  entityType: 'USER' | 'GROUP' | 'MSG_BOT';
  /** 保留来源类型，用于区分协作者与普通用户 */
  sourceType?: 'USER' | 'GROUP' | 'MSG_BOT' | 'AGENT';
}

/**
 * MentionBlot — 搜索选中的 @人 / @群 插入结果。
 * 在 Quill delta 中作为单字符 embed 存在，不可直接编辑。
 * 提交时取 id 而非 name 作为最终内容。
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class MentionBlot extends (EmbedCtor as any) {
  static blotName = 'mention-result';
  static tagName = 'span';
  static className = 'chatbox-mention-result';

  static create(value: MentionBlotValue): HTMLElement {
    const node = super.create(value) as HTMLElement;
    node.setAttribute('contenteditable', 'false');
    node.dataset.mentionId = value.id;
    node.dataset.mentionName = value.name;
    node.dataset.mentionType = value.entityType;
    node.dataset.mentionSourceType = value.sourceType ?? value.entityType;
    node.textContent = `@${value.name}`;
    return node;
  }

  static value(node: HTMLElement): MentionBlotValue {
    return {
      id: node.dataset.mentionId ?? '',
      name: node.dataset.mentionName ?? '',
      entityType: (node.dataset.mentionType ?? 'USER') as
        | 'USER'
        | 'GROUP'
        | 'MSG_BOT',
      sourceType: (node.dataset.mentionSourceType ?? node.dataset.mentionType ?? 'USER') as
        | 'USER'
        | 'GROUP'
        | 'MSG_BOT'
        | 'AGENT',
    };
  }
}
